import { AncillariesBundleConfig } from './AncillariesBundle';

export function getGridColumnsConfig(
  numberOfBundles: number,
): Record<string, string> {
  return {
    xs: 'repeat(1, 1fr)',
    sm:
      numberOfBundles > 2
        ? 'repeat(2, 1fr)'
        : `repeat(${numberOfBundles}, 1fr)`,
    md: `repeat(${numberOfBundles}, 1fr)`,
  };
}

export const getBundleIncludedItemsCodes = (
  bundle: AncillariesBundleConfig,
) => {
  const codes: string[] = [];

  bundle.items.map((item) => {
    if (item.included) codes.push(item.code);
  });

  return codes;
};

export const getBundleAttributes = (bundle: AncillariesBundleConfig) => {
  const { title, currencyCode, price } = bundle;
  const itemsCodes = getBundleIncludedItemsCodes(bundle);

  return {
    'data-code': title,
    'data-included': JSON.stringify(itemsCodes),
    'data-currency': currencyCode,
    'data-price': price,
  };
};
